import { render, staticRenderFns } from "./IntroductionArticle.vue?vue&type=template&id=0ea041e4&scoped=true&"
import script from "./IntroductionArticle.vue?vue&type=script&lang=js&"
export * from "./IntroductionArticle.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionArticle.vue?vue&type=style&index=0&id=0ea041e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea041e4",
  null
  
)

export default component.exports